export const INIT_USER = 'INIT_USER';
export const INIT_PRODUCTS = 'INIT_PRODUCTS';
export const INIT_PRODUCT_LIST_BY_TAG = 'INIT_PRODUCT_LIST_BY_TAG';
export const INIT_CIRCLE = 'INIT_CIRCLE';
export const INIT_PICTURE = 'INIT_PICTURE';
export const SAVE_POSITION = 'SAVE_POSITION';
export const SAVE_POSITION_PRODUCT_LIST = 'SAVE_POSITION_PRODUCT_LIST';
export const EXIT_APP = 'EXIT_APP';
export const LIKE = 'LIKE';
export const LOGIN = 'LOGIN';



// WEBPACK FOOTER //
// ./src/apps/portfolio/ActionTypes.js